module.exports = __webpack_public_path__ + "static/media/female.10a655da.svg";